import React from "react";
import { BarGraph } from "../../ui/Graph";
import PropTypes from "prop-types";
class GraphDashboardSMS {
  constructor(data) {
    this.data = data;
  }

  getLabelsAxisHour() {
    const data = this.data;
    const labels = [...new Set(data.map((item) => item.i_hour))];

    return labels;
  }

  getLabelsAxisX() {
    const labels = this.getLabelsAxisHour();

    const labelwithInfo = labels.map(
      (label) => `${String(label).padStart(2, "0")}:00`
    );
    return labelwithInfo;
  }

  getAxisYSendData() {
    const data = this.data;
    const sendData = data.map((item) => item.i_send);
    return sendData;
  }

  getAxisYResponseData() {
    const data = this.data;
    const responseData = data.map((item) => item.i_responses);
    return responseData;
  }
}
const GraphSmsDashboard = (props) => {
  const { loading = false, data = [] } = props;

  const { labelsX, sendDataAxisY, responseDataAxisY } = React.useMemo(() => {
    const graph = new GraphDashboardSMS(data);

    return {
      labelsX: graph.getLabelsAxisX(),
      sendDataAxisY: graph.getAxisYSendData(),
      responseDataAxisY: graph.getAxisYResponseData(),
    };
  }, [data]);

  const dataGraph = {
    labels: labelsX,
    datasets: [
      {
        type: "line",
        label: "Enviados",
        borderColor: "rgb(239, 68, 68)",
        backgroundColor: "rgb(239, 68, 68)",
        yAxisID: "y1",
        data: sendDataAxisY,
        fill: false,
        tension: 0.2,
        pointStyle: "circle",
        pointRadius: 0,
      },
      {
        type: "bar",
        label: "Respuestas",
        borderColor: "rgb(16, 163, 127)",
        backgroundColor: "rgb(16, 163, 127)",
        yAxisID: "y",
        data: responseDataAxisY,
        fill: false,
        tension: 0.2,
        pointStyle: "circle",
        pointRadius: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    interaction: {
      mode: "index",
      intersect: false,
    },

    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: {
          color: "#6b7280",
          font: {
            size: 12,
          },
        },
      },
      tooltip: {
        backgroundColor: "#ffffff",
        borderColor: "#e5e7eb",
        borderWidth: 1,
        borderRadius: 8,
        titleColor: "#000000",
        bodyColor: "#000000",
        padding: 10,
        displayColors: false,
      },

      title: {
        display: false,
      },
    },

    scales: {
      x: {
        ticks: {
          color: "#6b7280",
          font: { size: 12 },
        },

        display: true,
        grid: {
          lineWidth: 0.5,
        },
      },
      y: {
        type: "linear",
        display: true,
        position: "right",
      },

      y1: {
        type: "linear",
        position: "left",
        ticks: {
          color: "#6b7280",
          font: { size: 12 },
        },
        display: true,
        grid: {
          lineWidth: 0.5,
          drawOnChartArea: false,
        },
      },
    },
  };

  return (

  
        <BarGraph
          options={options}
          data={dataGraph}
          loading={loading}
          exportData={data}
        />

  );
};

GraphSmsDashboard.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.array,
};

export default GraphSmsDashboard;
